// ============================================================================
// CANCUN100 — pdfStyles.js
// Paleta de colores y helpers compartidos para los PDFs (Cliente y Comisión)
// ============================================================================
// Los colores se extrajeron del App.js (constante C) para mantener
// coherencia visual exacta con el dashboard.
// ============================================================================

export const COLORS = {
  // Marca
  rosa:           '#f74780',  // C.rosa del App.js
  rosaL:          '#ff6b9d',  // C.rosaL del App.js
  naranja:        '#ff8c42',  // C.naranja del App.js

  // Fondos suaves
  rosaSuave:      '#fdf2f5',  // Fondo caja folio y caja términos
  rosaSuaveBorde: '#fde2ea',
  fondoTabla:     '#fafafa',
  fondoFila:      '#f9fafb',

  // Tipografía
  blanco:         '#ffffff',
  textoOscuro:    '#1f2937',
  textoMedio:     '#4b5563',
  textoClaro:     '#9ca3af',
  textoMuyClaro: '#d1d5db',

  // Bordes
  bordeClaro:     '#e5e7eb',
  bordeMuyClaro: '#f3f4f6',

  // Acentos para los bloques de info del PDF Cliente
  acentoRosa:     '#f74780',
  acentoNaranja:  '#ff8c42',
  acentoPurpura:  '#a78bfa',
  acentoAzul:     '#4fc3f7',
  acentoVerde:    '#00d4a1',
};

// Helpers de formato (mismas que en App.js)
export const fmtMXN = (n) =>
  new Intl.NumberFormat('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);

export const fmtMXNDec = (n) =>
  new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

// Formato de fecha DD-MM-AAAA (el de los PDFs actuales)
export const fmtFechaCorto = (fecha) => {
  if (!fecha) return '';
  // Si viene 'YYYY-MM-DD'
  if (typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}/.test(fecha)) {
    const [y, m, d] = fecha.split('T')[0].split('-');
    return `${d}-${m}-${y}`;
  }
  return fecha;
};
